module.exports = __webpack_public_path__ + "img/addFriends.199eb87d.svg";